import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { getTradeOfferById } from "../../api/web";
import moment from "moment";

const TradeOfferDetail = (props) => {

    const id = props.match.params.id;
    const [initialLoading, setInitialLoading] = useState(true);
    const [offer, setOffer] = useState(null);

    useEffect(() => {
        getTradeOfferById(id).then((response) => {
            if (!response.error) {
                setOffer(response.payload);
            }
            setInitialLoading(false);
        });
    }, [id]);

    const statusBadge = (status) => {
        const map = {
            OPEN: { cls: 'bg-success text-white', style: {} },
            NEGOTIATION: { cls: 'bg-warning text-dark', style: {} },
            ACCEPTED: { cls: 'bg-info text-white', style: {} },
            CLOSED: { cls: 'bg-dark text-white', style: {} }
        };
        const c = map[status] || { cls: 'bg-secondary text-white', style: {} };
        return <span className={`badge ${c.cls}`} style={c.style}>{status || '—'}</span>;
    };

    const offerTypeLabel = (type) => {
        const map = { OPEN: 'Open Market', DIRECT: 'Direct Offer' };
        return map[type] ?? type ?? '—';
    };

    const personDisplay = (obj) => {
        if (!obj) return '—';
        if (typeof obj === 'object') {
            const n = [obj.first_name, obj.last_name].filter(Boolean).join(' ');
            return n || obj.username || obj.id || '—';
        }
        return `#${obj}`;
    };

    if (initialLoading) {
        return (
            <div className="content-body">
                <div className="container d-flex justify-content-center ht-100p">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mg-t-10">Loading trade offer</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!offer) {
        return (
            <div className="content-body">
                <div className="container pd-x-0">
                    <div className="mg-b-20">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/trade_offer">Trade Offers</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Not found</li>
                            </ol>
                        </nav>
                        <p className="tx-danger">Trade offer not found.</p>
                        <Link to="/trade_offer" className="btn btn-sm btn-primary">Back to Trade Offers</Link>
                    </div>
                </div>
            </div>
        );
    }

    const aggregatorName = offer.aggregator?.name ?? offer.aggregator?.pacra_id ?? '—';
    const cropName = offer.crop?.name ?? '—';
    const townName = offer.town?.name ?? '—';

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/trade_offer">Trade Offers</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Offer #{offer.id}</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-5 tx-spacing--1">Trade Offer #{offer.id}</h4>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <span className="tx-color-03 tx-13">{aggregatorName} · {cropName} · {townName}</span>
                            {statusBadge(offer.status)}
                        </div>
                    </div>
                    <div className="d-none d-md-block">
                        <Link to="/trade_offer" className="btn btn-sm pd-x-15 btn-secondary btn-uppercase">
                            <i className="wd-10 mg-r-5 fa fa-arrow-left"></i> Back to list
                        </Link>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="nav-wrapper mg-b-20 tx-13">
                            <ul className="nav nav-line nav-fill tx-medium">
                                <li className="nav-item">
                                    <a href="#info" className="nav-link active" data-bs-toggle="tab">
                                        <i className="ion-md-information-circle"/> Information
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="tab-content">
                            <div id="info" className="tab-pane fade active show">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row row-sm">
                                            <div className="col-md-6">
                                                <p><strong>Aggregator:</strong> {aggregatorName}</p>
                                                <p><strong>Crop:</strong> {cropName}</p>
                                                <p><strong>Town:</strong> {townName}</p>
                                                <p><strong>Status:</strong> {statusBadge(offer.status)}</p>
                                                <p><strong>Offer type:</strong> {offerTypeLabel(offer.offer_type)}</p>
                                                <p><strong>Quantity:</strong> {offer.quantity != null ? Number(offer.quantity).toLocaleString() : '—'} {offer.units ?? 'kg'}</p>
                                                <p><strong>Minimum quantity:</strong> {offer.minimum_quantity != null ? Number(offer.minimum_quantity).toLocaleString() : '—'} {offer.minimum_quantity_units ?? 'kg'}</p>
                                                <p><strong>Remaining quantity:</strong> {offer.standard_available_quantity != null ? Number(offer.standard_available_quantity).toLocaleString() : '—'}</p>
                                                <p><strong>Price:</strong> {offer.price != null ? Number(offer.price).toLocaleString() : '—'}</p>
                                                <p><strong>Available:</strong> {offer.available ? 'Yes' : 'No'}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><strong>Last traded price:</strong> {offer.last_traded_price != null ? Number(offer.last_traded_price).toLocaleString() : '—'}</p>
                                                <p><strong>Last traded date:</strong> {offer.last_traded_date ? moment(offer.last_traded_date).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                                <p><strong>Moisture content:</strong> {offer.moisture_content != null ? offer.moisture_content : '—'}</p>
                                                <p><strong>Farmer:</strong> {personDisplay(offer.farmer)}</p>
                                                <p><strong>Created by:</strong> {personDisplay(offer.created_by)}</p>
                                                <p><strong>Date created:</strong> {offer.date_created ? moment(offer.date_created).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                                <p><strong>Date modified:</strong> {offer.date_modified ? moment(offer.date_modified).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                                {offer.notes ? (
                                                    <p><strong>Notes:</strong><br/><span className="tx-color-03">{offer.notes}</span></p>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TradeOfferDetail;
